<template>
  <div class="info__wrapper">
    <q-linear-progress v-if="this.isFetching" indeterminate />
    <NotFoundText v-if="!this.data" />
    <div v-else class="content">
      <div class="flexWrapper">
        <h3 class="flexWrapperTitle">Общие сведения</h3>
        <div class="flexWrapperContent">
          <BlockItem
            title="Дата начала"
            >{{ this.data?.data?.start_date }}</BlockItem
          >
          <BlockItem
            title="Дата окончания"
            >{{ this.data?.data?.finish_date }}</BlockItem
          >
          <BlockItem
            title="Название проекта"
            >{{ this.data?.data?.project_name }}</BlockItem
          >
          <BlockItem
            title="Тип проекта"
            >{{ this.data?.data?.project_type_name }}</BlockItem
          >
        </div>
      </div>

      <div class="flexWrapper">
        <h3 class="flexWrapperTitle">Назначенные лица</h3>
        <div class="flexWrapperContent">
          <CustomTable
            title=""
            :rowsData="this.data?.employees || []"
            :columns="this.residentResponsibilitiesColumns"
            :loading="isFetching"
            :hideTopTitle="true"
            :custom-body="true"
            :bottomRow="true"
            :allWidth="true"
            :striped="true"
            :bordered="true"
            :hoverless="true"
            :sticky-header="false"
            separator="cell"
          >
            <template #customBody="props">
              <template
                v-for="(item, index) in props.row.assign_types"
                :key="item.employee_id"
              >
                <q-tr>
                  <q-td
                    v-if="index === 0"
                    :rowspan="props.row.assign_types.length"
                    align="left"
                    vertical-align="center"
                    style="background: #fff;"
                  >
                    {{ props.row.contractor_name }}
                  </q-td>
                  <q-td
                    align="left"
                    vertical-align="center"
                    style="background: #fff; border-left: 1px solid rgba(0, 0, 0, 0.12);"
                  >
                    {{ item.assign_type_name }}
                  </q-td>
                  <q-td
                    align="left"
                    vertical-align="center"
                    style="background: #fff;"
                  >
                    {{ item.fio }}
                  </q-td>
                </q-tr>
              </template>
            </template>
          </CustomTable>
        </div>
      </div>

      <div class="flexWrapper" v-if="this.documents.length > 0">
        <h3 class="flexWrapperTitle">Договора</h3>
        <div class="flexWrapperContent">
          <CustomTable
            title=""
            :rowsData="this.documents || []"
            :columns="this.residentDocumentsInfoColumns"
            :loading="isFetching"
            :hideTopTitle="true"
            :custom-body="true"
            :bottomRow="true"
            :allWidth="true"
            :striped="true"
            :bordered="true"
            :hoverless="true"
            :sticky-header="false"
            separator="cell"
          >
            <template #customBody="props">
              <q-tr>
                <q-td
                  align="center"
                  vertical-align="center"
                  style="background: #fff;"
                >
                  {{ props.row.project_agreement_id }}
                </q-td>
                <q-td
                  align="left"
                  vertical-align="left"
                  style="background: #fff;"
                >
                  {{ props.row.doc_name }}
                </q-td>
                <q-td
                  align="left"
                  vertical-align="center"
                  style="background: #fff;"
                >
                  <div class="signature-cell">
                    <div class="signer-name">
                      {{ props.row.project_head_name }}
                      {{ props.row.project_head_fio }}
                    </div>

                    <div
                      v-if="!props.row.project_head_is_sign && props.row.project_head_can_sign"
                      class="signature-action"
                    >
                      <q-btn
                        size="sm"
                        color="primary"
                        icon="edit"
                        label="Подписать"
                        class="signature-btn"
                        :loading="signing[props.row.project_agreement_id]"
                        :disable="signing[props.row.project_agreement_id]"
                        @click="signDocument(props.row.project_agreement_id)"
                      />
                    </div>

                    <div
                      v-else-if="props.row.project_head_is_sign"
                      class="signature-status signed"
                    >
                      <span class="status-text">Подписано</span>
                      <span
                        v-if="props.row.project_head_date"
                        class="signature-date"
                      >
                        {{ props.row.project_head_date }}
                      </span>
                    </div>

                    <div v-else class="signature-status pending">
                      <span class="status-text">На подписании</span>
                    </div>
                  </div>
                </q-td>
                <q-td
                  align="left"
                  vertical-align="center"
                  style="background: #fff;"
                >
                  <div class="signature-cell">
                    <div class="signer-name">
                      {{ props.row.contractor_name }}
                      {{ props.row.contractor_fio }}
                    </div>

                    <div
                      v-if="!props.row.contractor_is_sign && props.row.contractor_can_sign"
                      class="signature-action"
                    >
                      <q-btn
                        size="sm"
                        color="primary"
                        icon="edit"
                        label="Подписать"
                        class="signature-btn"
                        :loading="signing[props.row.project_agreement_id]"
                        :disable="signing[props.row.project_agreement_id]"
                        @click="signDocument(props.row.project_agreement_id)"
                      />
                    </div>

                    <div
                      v-else-if="props.row.contractor_is_sign"
                      class="signature-status signed"
                    >
                      <span class="status-text">Подписано</span>
                      <span
                        v-if="props.row.contractor_date"
                        class="signature-date"
                      >
                        {{ props.row.contractor_date }}
                      </span>
                    </div>

                    <div v-else class="signature-status pending">
                      <span class="status-text">На подписании</span>
                    </div>
                  </div>
                </q-td>
                <q-td
                  align="center"
                  vertical-align="center"
                  style="background: #fff;"
                >
                  <Clickable
                    style="display: flex; align-items: center; gap: 5px;"
                    hideUnderline
                    :disabled="this.downloadingSigned[props.row.project_agreement_id] || !!this.downloading[props.row.project_agreement_id]"
                    @click="() => handleDownloadPDF(props.row.project_agreement_id)"
                  >
                    <ShinyButton
                      v-if="this.downloadingSigned[props.row.project_agreement_id] || !!this.downloading[props.row.project_agreement_id]"
                      text="Скачать"
                    />
                    <span v-else>Скачать</span>
                    <q-icon name="download" />
                  </Clickable>
                </q-td>

                <q-td v-if="this.isSbs">
                  <p
                    v-if="props.row?.is_sent_to_1c"
                    class="tw-flex tw-items-center tw-justify-center tw-text-green-500"
                  >
                    <CheckOrClose :value="true" />Отправлено в 1С
                  </p>
                  <CustomButton
                    v-else
                    size="sm"
                    style="height: 30px; width: fit-content; font-size: 11px; white-space: nowrap;"
                    :loading="this.sending"
                    @click="() => this.sendTo1C(props.row.contractor_agreement_list_id)"
                    >Отправить в 1С</CustomButton
                  >
                  <p v-if="!!props.row.guid">GUID: {{ props.row.guid }}</p>
                  <p
                    v-if="!!props.row.error"
                    class="tw-text-red-700 tw-cursor-pointer tw-mt-2"
                  >
                    Ошибка
                    <q-icon name="info" />
                    <q-popup-proxy anchor="top middle" self="bottom middle">
                      <q-banner
                        class="tw-p-2 tw-bg-red-100"
                        style="min-height: auto;"
                      >
                        <span
                          class="tw-text-red-900"
                          >{{ props.row.error }}</span
                        >
                      </q-banner>
                    </q-popup-proxy>
                  </p>
                </q-td>
              </q-tr>
            </template>
          </CustomTable>
        </div>
      </div>

      <div class="flexWrapper" v-if="this.otherDocuments.length > 0">
        <h3 class="flexWrapperTitle">Документы</h3>
        <div class="flexWrapperContent">
          <CustomTable
            title=""
            :rowsData="this.otherDocuments || []"
            :columns="this.otherDocumentsInfoColumns"
            :loading="isFetching"
            :hideTopTitle="true"
            :custom-body="true"
            :bottomRow="true"
            :allWidth="true"
            :striped="true"
            :bordered="true"
            :hoverless="true"
            :sticky-header="false"
            separator="cell"
          >
            <template #customBody="props">
              <q-tr>
                <q-td
                  align="center"
                  vertical-align="center"
                  style="background: #fff;"
                >
                  {{ props.row.project_document_id }}
                </q-td>
                <q-td
                  align="left"
                  vertical-align="left"
                  style="background: #fff;"
                >
                  {{ props.row.project_document_type_name }}
                </q-td>
                <q-td align="left" vertical-align="center">
                  <div
                    style="background: #fff; display: flex; flex-wrap: wrap; justify-content: space-around;"
                  >
                    <div
                      v-for="(signer, index) in props.row.signers"
                      :key="index"
                    >
                      <div class="signer-name">
                        {{ signer.dn_fio }}
                      </div>

                      <div
                        v-if="!signer.is_signed && signer.can_sign"
                        class="signature-action"
                      >
                        <q-btn
                          size="sm"
                          color="primary"
                          icon="edit"
                          label="Подписать"
                          class="signature-btn"
                          :loading="signing[props.row.project_document_id]"
                          :disable="signing[props.row.project_document_id]"
                          @click="signOtherDocument(props.row.project_document_id)"
                        />
                      </div>

                      <div
                        v-else-if="signer.is_signed"
                        class="signature-status signed"
                      >
                        <span class="status-text">Подписано</span>
                        <span v-if="signer.sign_date" class="signature-date">
                          {{ signer.sign_date }}
                        </span>
                      </div>

                      <div v-else class="signature-status pending">
                        <span class="status-text">На подписании</span>
                      </div>
                    </div>
                  </div>
                </q-td>
                <q-td
                  align="center"
                  vertical-align="center"
                  style="background: #fff;"
                >
                  <Clickable
                    style="display: flex; align-items: center; gap: 5px;"
                    hideUnderline
                    :disabled="this.downloadingSigned[props.row.project_document_id] || !!this.downloading[props.row.project_document_id]"
                    @click="() => downloadDoc(props.row.project_document_id, props.row.project_document_name)"
                  >
                    <ShinyButton
                      v-if="this.downloadingSigned[props.row.project_document_id] || !!this.downloading[props.row.project_document_id]"
                      text="Скачать"
                    />
                    <span v-else>Скачать</span>
                    <q-icon name="download" />
                  </Clickable>
                </q-td>

                <q-td v-if="this.isSbs" align="center" vertical-align="center">
                  <p
                    v-if="props.row?.is_sent_to_1c"
                    class="tw-flex tw-items-center tw-justify-center tw-text-green-500"
                  >
                    <CheckOrClose :value="true" />Отправлено в 1С
                  </p>
                  <CustomButton
                    v-else
                    size="sm"
                    style="height: 30px; width: fit-content; font-size: 11px; white-space: nowrap;"
                    :loading="this.sending"
                    @click="() => this.sendTo1C(props.row.contractor_agreement_list_id)"
                    :disabled="true"
                    >Отправить в 1С</CustomButton
                  >
                  <p v-if="!!props.row.guid">GUID: {{ props.row.guid }}</p>
                  <p
                    v-if="!!props.row.error"
                    class="tw-text-red-700 tw-cursor-pointer tw-mt-2"
                  >
                    Ошибка
                    <q-icon name="info" />
                    <q-popup-proxy anchor="top middle" self="bottom middle">
                      <q-banner
                        class="tw-p-2 tw-bg-red-100"
                        style="min-height: auto;"
                      >
                        <span
                          class="tw-text-red-900"
                          >{{ props.row.error }}</span
                        >
                      </q-banner>
                    </q-popup-proxy>
                  </p>
                </q-td>
              </q-tr>
            </template>
          </CustomTable>
        </div>
      </div>

      <!-- Блок "Финансовая информация" временно скрыт как неактуальный -->

      <div class="flexWrapper">
        <h3 class="flexWrapperTitle">Заказанный объем материалов</h3>
        <div class="flexWrapperContent">
          <CustomTable
            title=""
            :rowsData="this.data?.materials || []"
            :columns="this.materialRequestsColumnsSmall"
            :loading="isFetching"
            :hideTopTitle="true"
            :custom-body="true"
            :bottomRow="true"
            :allWidth="true"
            :striped="true"
            :bordered="true"
            :sticky-header="false"
            separator="cell"
          >
            <template #customBody="props">
              <q-tr style="background-color: #c4d6ff !important;">
                <custom-table-cell
                  align="left"
                  vertical-align="center"
                  colspan="3"
                >
                  <span style="font-weight: 700;"
                    >Подъезд {{ props.row.entrance }}</span
                  >
                </custom-table-cell>
              </q-tr>
              <q-tr v-for="item in props.row.materials" :key="item.material_id">
                <custom-table-cell align="left" vertical-align="center">
                  {{ item.material_name }}
                </custom-table-cell>
                <custom-table-cell align="right" vertical-align="center">
                  {{ `${item.material_cnt} ${item.sell_unit_name}` }}
                </custom-table-cell>
                <custom-table-cell align="right" vertical-align="center">
                  <Amount :value="item.material_sum" />
                </custom-table-cell>
              </q-tr>
            </template>

            <template v-if="this.data?.materials?.length" #bottomRow="props">
              <q-tr class="bg-grey-3">
                <q-td colspan="2" align="right">Итого</q-td>
                <q-td align="right" class="text-bold">
                  <Amount :value="this.amountSum" />
                </q-td>
              </q-tr>
            </template>
          </CustomTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDocuments, getFloorProjectInfo, materialRequestsColumnsSmall, residentResponsibilitiesColumns, materialRequestsSumColumns, residentFinanceInfoColumns, residentDocumentsInfoColumns, residentDocumentsInfoColumns1C, signDocument, downloadDocumentPDF, sendAgreementTo1C, otherDocumentsInfoColumns } from './services'
import BlockItem from "@/components/common/BlockItem";
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import Amount from "@/components/common/Amount.vue";
import Clickable from "@/components/common/Clickable";
import ShinyButton from "@/components/common/ShinyButton";
import CheckOrClose from "@/components/common/CheckOrClose";
import CustomButton from "@/components/common/CustomButton.vue";
import { formatDate } from "@/utils/formatDate";
import { getProjectDocs, signDocuments, downloadProjectDocumentPDF } from '@/views/ProjectsEntry/services';

export default {
  name: "ResidentInfo",
  components: { BlockItem, CustomTable, CustomTableCell, Amount, Clickable, ShinyButton, CheckOrClose, CustomButton },
  props: ['projectId', 'isSbs'],
  data() {
    return {
      materialRequestsColumnsSmall,
      residentResponsibilitiesColumns,
      materialRequestsSumColumns,
      residentFinanceInfoColumns,
      residentDocumentsInfoColumns: this.isSbs ? residentDocumentsInfoColumns1C : residentDocumentsInfoColumns,
      otherDocumentsInfoColumns,
      isFetching: false,
      data: null,
      documents: [],
      sending: false,
      downloading: {},
      downloadingSigned: {},
      signing: {},
      otherDocuments: [],
      params: {
        project_id: this.projectId,
        project_document_type_id: 3
      },
    }
  },
  watch: {
    isSbs(newVal) {
      this.residentDocumentsInfoColumns = newVal ? residentDocumentsInfoColumns1C : residentDocumentsInfoColumns;
    }
  },
  methods: {
    formatDate,
    async sendTo1C(contractor_agreement_list_id) {
      if (this.sending) return
      this.sending = true
      const res = await sendAgreementTo1C(this.projectId, contractor_agreement_list_id);
      this.sending = false
      if (!res) {
        this.getDocuments();
        return
      }
      this.documents = res;
    },
    async signDocument(project_agreement_id) {
      if (this.signing[project_agreement_id]) return;

      this.signing[project_agreement_id] = true;
      try {
        const res = await signDocument(
          { project_agreement_id },
          { ...this.$route?.query }
        );
        if (!res) return;

        window.open(res?.redirect_url, "_blank");

        await this.getDocuments();
      } finally {
        this.signing[project_agreement_id] = false;
      }
    },
    async handleDownloadPDF(project_agreement_id) {
      if (this.downloading[project_agreement_id]) return;
      this.downloading[project_agreement_id] = true;
      try {
        await downloadDocumentPDF(project_agreement_id);
      } finally {
        this.downloading[project_agreement_id] = false;
      }
    },
    async getDocuments() {
      const res = await getDocuments(this.projectId)
      this.documents = res || []
    },
    async getData() {
      this.isFetching = true
      const res = await getFloorProjectInfo(this.projectId)
      this.isFetching = false
      if (!res) return
      this.data = res
    },
    async getOtherDocuments() {
      this.isFetching = true
      const res = await getProjectDocs(this.params)
      this.isFetching = false
      if (!res) return
      this.otherDocuments = res || []
    },
    async signOtherDocument(project_document_id) {
      this.signing[project_document_id] = true;
      const res = await signDocuments({ project_document_id });
      this.signing[project_document_id] = false;
      if (!res) return;
      window.open(res?.redirect_url, "_blank");
      await this.getOtherDocuments();
    },
    async downloadDoc(project_document_id, fileName) {
      this.downloading[project_document_id] = true;
      await downloadProjectDocumentPDF(project_document_id, fileName)
      this.downloading[project_document_id] = false;
    },
  },
  computed: {
    amountSum() {
      return this.data?.materials.reduce((acc, item) => {
        return acc + (item.materials?.reduce((acc, material) => {
          return acc + (material?.material_sum || 0)
        }, 0) || 0)
      }, 0)
    },
    sumsAmount() {
      const amount = {
        total: 0,
        paid: 0,
        waiting: 0,
        remaining: 0
      }
      this.data?.sums?.forEach((item) => {
        amount.total += item.total_sum
        amount.paid += item.paid_sum
        amount.waiting += item.processing_sum
        amount.remaining += item.remaining_sum
      })
      return amount
    },
  },
  mounted() {
    this.getData()
    this.getDocuments()
    this.getOtherDocuments()
  }
};
</script>

<style scoped lang="scss">
.info__wrapper {
  max-width: 875px;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 25px;
}

.flexWrapper {
  padding: 25px;
  border-radius: 10px;
  box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.1);
  width: 100%;
}

.flexWrapperTitle {
  font-size: 18px;
  line-height: 25px;
  font-weight: 500;
  color: #000;
  margin: 0;
}

.flexWrapperContent {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 20px;
  width: 100%;
}

.signature-cell {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 45px;
}

.signer-name {
  font-weight: 500;
  color: #1a1a1a;
  font-size: 14px;
  line-height: 1.4;
}

.signature-action {
  margin-top: 4px;
}

.signature-btn {
  font-size: 12px;
  padding: 4px 12px;
  border-radius: 6px;
  font-weight: 500;
  text-transform: none;
  box-shadow: 0 2px 4px rgba(25, 118, 210, 0.15);
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(25, 118, 210, 0.25);
  }
}

.signature-status {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  margin-top: 4px;
  width: fit-content;

  &.signed {
    background-color: #e8f5e8;
    color: #2e7d32;
    border: 1px solid #c8e6c9;
  }

  &.pending {
    background-color: #fff3e0;
    color: #f57c00;
    border: 1px solid #ffcc02;
  }
}

.status-text {
  font-size: 11px;
  font-weight: 500;
}

.signature-date {
  color: #666;
  font-size: 11px;
  font-weight: 400;
  margin-left: 4px;
  white-space: nowrap;
}
</style>
